<template>
  <div class="box">
		<div class="container">
			<div class="header">
				<div class="logo">
					<img src="../../assets/image/logo2.png" alt="" />
				</div>
				<div class="headerImg"  @click="headerNavBool=!headerNavBool">
					<!--<img src="../assets/image/doctorHeader.png" alt="" />-->
					<span>管理员</span>
					<div  @click="tiuchuFn">
						退出登录</div>
				</div>
			</div>
			<div class="content">
				<div class="aside">
					<el-menu
		      	  router
			        :default-active="currentMenu"
			        background-color="#666666"
			        text-color="#ffffff"
			        active-text-color="red">
			        <nav-menu :navMenus="leftMenus"></nav-menu>
			      </el-menu>
			        <!--:default-openeds="['诊所管理','用户管理']"-->
				</div>
				<div class="main"> 
			   		<router-view v-if="isRouterAlive"></router-view>
				</div>
			</div>
		</div>
  </div>
</template>
<script>
	import NavMenu  from './../../component/NavMenu.vue'
	import {data1} from './../../assets/js/leftData.js'
//	import {get_users_rows,logout,update_login,set_first_login} from '../http/api.js'
	import { mapState ,mapMutations} from 'vuex'
export default {
	components:{
		NavMenu
	},
  data () {
    return {
				currentMenu:'',
    		leftMenus:data1.listMa,
		    companys_row:{},
    		headerNavBool:false,
		    timer:null,
		    shouciBoll:false,
		    reload:this.reload,
		    isRouterAlive:false
    }
  },
  created(){
		this.getCookietoken();
		this.getUrl();
  },
	methods:{
		...mapMutations(['changeUser']),
		getUrl () {
				let currentUrl = window.location.href;
				this.currentMenu = currentUrl.split('#')[1];
			},
			tiaozhuan(){
				this.shouciBoll=false;
				this.$router.push('/indexAt/personalInformation')
			},
			 move(e){
            let odiv = e.target;  
            let disX = e.clientX - odiv.offsetLeft;
            let disY = e.clientY - odiv.offsetTop;
            document.onmousemove = (e)=>{    
                let left = e.clientX - disX;    
                let top = e.clientY - disY;
	            	odiv.style.left = left + 'px';
	            	odiv.style.top = top + 'px';
            };
            document.onmouseup = (e) => {
                document.onmousemove = null;
                document.onmouseup = null;
            };
    	},
			tiuchuFn(){
				this.$message({
        message: "退出成功",
        type: 'success',
        duration:1000,
        onClose:()=>{
           	this.$router.push({
	            		name:'login'
	            	})
	        }
				})
			},
			 getCookietoken(){
		    	 if (document.cookie.length > 0) {
		            var arr = document.cookie.split('; '); //这里显示的格式需要切割一下自己可输出看下
		            for (var i = 0; i < arr.length; i++) {
		                var arr2 = arr[i].split('='); //再次切割
		                //判断查找相对应的值
		                if (arr2[0] == 'token') {
		                   var token=arr2[1]; //保存到保存数据的地方
		                }else if(arr2[0] == 'cpy_id'){
		                  var cookiecpy_id=arr2[1]; //保存到保存数据的地方
		                }else if(arr2[0] == 'uid'){
		                  var cookieuid=arr2[1]; //保存到保存数据的地方
		                }else if(arr2[0] == 'is_first_login'){
		                  var is_first_login=arr2[1]; //保存到保存数据的地方
		                }else if(arr2[0] == 'userName'){
		                  var username=arr2[1]; //保存到保存数据的地方
		                }
		            }
		            
		        }
    			this.changeUser({uid:cookieuid,token:token,is_first_login:is_first_login,uname:username});
    			this.reload();
		    },
		    reload (){
		       this.isRouterAlive = false
		       this.$nextTick(function(){
		          this.isRouterAlive = true
		       })
		    }
	}
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.box{
		width: 100%;
		height: 100%;
	}
	.container{
		width: 100%;
		height: 100%;
	}
	.header{
		height: 73px;
		width: 100%;
		background: #FFFFFF;
		box-shadow:0px 2px 4px 0px rgba(155,155,155,0.5);
	}
	.header>.logo{
		float: left;
		width:327px;
		/*margin-left: -250px;*/
		height: 100%;
		background:linear-gradient(90deg,rgba(74,74,74,1) 0%,rgba(36,55,108,1) 100%);
		/*box-shadow:0px 2px 4px 0px rgba(0,0,0,0.5);*/
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.header>.logo>img{
		height: 34px;
	}
	.header>.headerImg{
		/*float: right;*/
		display: flex;
		height: 100%;
		align-items: center;
		justify-content: center;
		margin-right: 32px;
		/*cursor: pointer;*/
		position: relative;
	}
	.header>.headerImg>img{
		width: 42px;
		border-radius: 50%;
		margin-right: 12px;
	}
	.header>.headerImg>span{
		display: flex;
		align-items: center;
		font-size:15px;
		font-weight:600;
		color:rgba(153,153,153,1);
		letter-spacing: 1px;
	}
		.header>.headerImg>span>img{
			width:16px;
			height:16px;
			margin-right: 2px;
			margin-left: 2px;
		}
		.header>.headerImg>span>span{
			color: #4A4A4A;
		}
		.header>.headerImg>div{
			position: absolute;
			right: 0;
			display: flex;
			align-items: center;
			font-size:15px;
			font-weight:600;
			color:#9F9C9D;
			cursor: pointer;
		}
		.header>.headerImg>div>img{
			width:16px;
			height:16px;
			margin-right: 2px;
		}
		.header>.headerImg>div>img:nth-child(2){
			display: none;
		}
		.header>.headerImg>div:hover{
			color: #0C77FE;
		}
		.header>.headerImg>div:hover img:nth-child(2){
			display: block;
		}
			.header>.headerImg>div:hover img:nth-child(1){
			display: none;
		}
	.headerNav{
		width:121px;
		/*height:122px;*/
		background:rgba(255,255,255,1);
		box-shadow:4px 0px 12px 0px rgba(0,0,0,0.13);
		border-radius:10px;
		position: absolute;
		top: 75px;
		right: -20px;
		z-index: 999;
		padding: 10px 0px 10px 20px;
		opacity: 1;
		display: none;
		transform: all .5s;
}
.headerNav>div{
	height: 39px;
	line-height: 39px;
	text-align: left;
	font-size:14px;
	font-family:PingFangSC-Regular;
	font-weight:500;
	color:rgba(0,0,0,1);
}
.headerNav>div:hover{
	font-weight: bold;
}
.headerNav.active{
	transform: all .1s;
	display: block;
	opacity: 1;
	
}
.headerNav>div:nth-child(2){
	border-top:2px solid #F1F1F1 ;/*px*/
	border-bottom:2px solid #F1F1F1 ;/*px*/
}
	.content{
		width: 100%;
		overflow: hidden;
		height: 100%;
	}
	.aside{
		width: 327px;
		height: 100%;
		background:rgba(35,37,49,1);
		float: left;
	}
	.main{
		margin-left: 327px;
		/*height: 828px;*/
		height:100%;
		display: flex;
		justify-content: center;
		align-content: center;
		padding: 18px;
		/*background: #FFFFFF;*/
	}
	.grxxDialoglogin{
		width: 100%;
		height: 100%;
		z-index: 1000;
		position: absolute;
		top: 0;
		left: 0;
		background: rgba(0,0,0,.2);
	}
	.grxxDialogloginbox{
		width: 822px;
		height: 339px;
		padding: 40px 30px;
		background: #FFFFFF;
		box-shadow: 0px  1px 10px rgba(0,0,0,.13);
		border-radius: 11px;
		position: absolute;
		top: 50%;
		left: 50%;

		transform: translate(-50%,-50%) ;
	}
	.grxxDialogloginbox>div>p{
		letter-spacing: 1px;
	}
	.grxxDialogloginbox>div:nth-child(1){
		padding-bottom: 18px;
		margin-bottom: 20px;
		padding-bottom: ;
		border-bottom:1px solid #F1F1F1;
	}
	.grxxDialogloginbox>div:nth-child(1)>p{
		font-size: 19px;
		line-height: 26px;
		color: black;
	}
	.grxxDialogloginbox>div:nth-child(1)>p:nth-child(1){
		text-align: right;
	}
	.grxxDialogloginbox>div:nth-child(1)>p:nth-child(1)>i{
		cursor: pointer;
	}
	.grxxDialogloginbox>div:nth-child(2)>p{
		color: #9B9B9B;
		font-size: 15px;
		line-height: 24px;
	}
	.grxxDialogloginbox>div:nth-child(2)>p>span{
		color: #0078FF;
		cursor: pointer;
		border-bottom: 1px solid #0078FF;
	}
	.grxxDialogloginbox>div:nth-child(2){
		margin-bottom: 42px;
	}
	.grxxDialogloginbox>div:nth-child(3){
		display: flex;
	}
	.grxxDialogloginbox>div:nth-child(3)>div:nth-child(1){
		width: 127px;
		height: 32px;
		margin-right: 10px;
	}
	.grxxDialogloginbox>div:nth-child(3)>div:nth-child(2){
		width: 158px;
		height: 32px;
	}
	.grxxDialogloginbox>div:nth-child(3)>div:nth-child(1)>button{
		width: 127px;
		height: 32px;
		background: #D7D7D7;
		box-shadow: 0 1px 4px 0 rgba(121,139,149,0.44);
	}
	.grxxDialogloginbox>div:nth-child(3)>div:nth-child(2)>button{
		width: 158px;
		height: 32px;
		background: #0078FF;
		box-shadow: 0 1px 4px 0 rgba(121,139,149,0.44);
	}
	.grxxDialogloginbox>div:nth-child(3)>div>button{
		font-size: 12px;
		color: #FFFFFF;
		border-radius:3px ;
	}
</style>


// WEBPACK FOOTER //
// src/components/MA/indexMa.vue